var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12145_678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#EFF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1355 31.3439C30.8272 31.0252 33.4719 30.3899 36.0148 29.4513C33.8613 27.0659 32.6714 23.9652 32.6761 20.7515V19.668C32.6761 17.3691 31.7629 15.1644 30.1373 13.5388C28.5118 11.9132 26.307 11 24.0081 11C21.7092 11 19.5045 11.9132 17.8789 13.5388C16.2533 15.1644 15.3401 17.3691 15.3401 19.668V20.7515C15.3444 23.9654 14.154 27.0661 12 29.4513C14.5036 30.3759 17.143 31.0188 19.8807 31.3439M28.1355 31.3439C25.3935 31.6691 22.6227 31.6691 19.8807 31.3439M28.1355 31.3439C28.3437 31.9938 28.3955 32.6836 28.2866 33.3573C28.1778 34.031 27.9114 34.6695 27.5091 35.2207C27.1068 35.772 26.5801 36.2205 25.9717 36.5297C25.3633 36.8388 24.6905 37 24.0081 37C23.3257 37 22.6529 36.8388 22.0445 36.5297C21.4361 36.2205 20.9094 35.772 20.5071 35.2207C20.1049 34.6695 19.8384 34.031 19.7296 33.3573C19.6207 32.6836 19.6725 31.9938 19.8807 31.3439",
    stroke: "#8152E0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12145_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdReminder);
export default __webpack_public_path__ + "static/media/sd-reminder.43fbe2453e9ec4ca39ea58c8c56f5dbe.svg";
export { ForwardRef as ReactComponent };